/**
 * Spec 2.9 — the advisory limitation, rendered as a persistent component
 * rather than buried in a terms page.
 *
 * The rule this encodes: the limitation must be visible at the point of use.
 * An operator looking at a "mold protection" flag needs to see, without
 * scrolling or hovering, that it is an advisory and not a safety stop.
 */

export function AdvisoryBanner({
  compact = false,
  disclaimer,
}: {
  compact?: boolean;
  disclaimer?: string;
}) {
  return (
    <div className="advisory-banner" role="note" aria-label="Advisory system limitation">
      <span className="tag">Advisory</span>
      <p>
        {compact ? (
          <>
            <strong>Advisory only.</strong> This output never stops a machine and is
            never wired into a EUROMAP 67 / 81 safety interlock. A certified safety
            system must be procured separately.
          </>
        ) : (
          disclaimer ?? (
            <>
              <strong>PlasticVision is an advisory quality and analytics system.</strong>{' '}
              It does not, and cannot, stop a machine. Any &ldquo;mold protection&rdquo;
              output is a damage-risk advisory for a human operator, or a signal to a
              non-safety-rated 24 V reject gate. It is never wired into a EUROMAP 67
              (or EUROMAP 81) safety interlock circuit, and it is not a substitute
              for one.
            </>
          )
        )}
      </p>
    </div>
  );
}

/** Small inline marker for tables and cards where a full banner is too heavy. */
export function AdvisoryTag() {
  return (
    <span className="pill advisory" title="Advisory output — never a safety-rated machine stop">
      Advisory
    </span>
  );
}
